import { Transform } from 'class-transformer';

/**
 * Serializes a numeric field to `number | null`, preserving "no value" as `null`
 * instead of collapsing it to `0`.
 *
 * Use this in place of `@Type(() => Number)` for optional numeric inputs: masked
 * inputs (e.g. ngx-mask `separator.2`) emit an empty string `''` when cleared, and
 * `Number('')`/`Number(null)` both evaluate to `0` — turning a cleared/never-set
 * field into a spurious `0` on save (and a false audit-trail change).
 */
export function NullableNumber() {
  return Transform(({ value }) =>
    value === null || value === undefined || value === '' ? null : Number(value)
  );
}
